import { z } from 'zod';

/**
 * A character's Tone (DEATH-PULSE §4) as its owner gets it (OC-2: only its owner): its value at a
 * game time, since when it rests (null: it does not), and the technique its Dissonance seals
 * (TO-5; null: none). Its client reads it now with the shared `toneAt` and `toneRules`.
 */
export const ToneStateSchema = z.object({
  value: z.number().min(0).max(1_000),
  since: z.number().int().nonnegative(),
  restingSince: z.number().int().nonnegative().nullable(),
  /** How fast its rest raises it where it rests (BX-2: a home with a chimney); absent, 1. */
  restFactor: z.number().min(1).max(10).optional(),
  sealed: z.string().min(1).max(64).nullable(),
});
export type ToneStateView = z.infer<typeof ToneStateSchema>;

/** What a client needs of the Tone's rules to read it (DEATH-PULSE §4, §5). */
export const ToneRulesViewSchema = z.object({
  max: z.number().positive(),
  regenPerHour: z.number().min(0),
  restPerHour: z.number().min(0),
  low: z.number().min(0),
  dissonance: z.array(z.object({ below: z.number().min(0), state: z.string() })),
});
export type ToneRulesView = z.infer<typeof ToneRulesViewSchema>;
